import React, { Component } from 'react';
import MenuSublistSec from './MenuSublistSec';

const alphabetKeyArray = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
];

class LuxeBrandList extends Component {
  constructor(props) {
    super(props);
    this.scroller = React.createRef();
    this.state = {
      defaultSelectedKey: '',
      alphabetKeyNoDataArray: [],
      mapPosition: new Map()
    };
  }

  componentDidMount() {
    const { values } = this.props;
    const avaliableData = values.map(value => value.name);
    if (avaliableData[0]) {
      this.setState({ defaultSelectedKey: avaliableData[0] || '' });
    }
    this.setPosition(avaliableData);
    this.setNoDataArray(avaliableData);
  }

  checkNextAlphabetDataFromColumn(menuColMapEntity, lastColumn) {
    let nextColumn = lastColumn + 1;
    let fetchDataFromColumn = menuColMapEntity[nextColumn]?.colData || [];
    let filterNonAlphabetData = fetchDataFromColumn.filter(colValue => {
      return colValue.name !== '';
    });
    if (!filterNonAlphabetData || filterNonAlphabetData.length === 0) {
      return this.checkNextAlphabetDataFromColumn(menuColMapEntity, nextColumn);
    } else {
      return {
        fetchDataFromColumn,
        filterNonAlphabetData,
        nextColumn
      };
    }
  }

  setPosition(avaliableData) {
    const { menuColMap } = this.props;
    const { results: menuColMapRes = [], entities: menuColMapEntity = {} } = menuColMap;
    let lastPosition = 0;
    let lastColumn = 1;
    let mapPositionData = new Map();
    let pushData = 0;
    alphabetKeyArray.map(value => {
      const avaliableValueIndex = avaliableData.indexOf(value);
      if (avaliableValueIndex >= 0) {
        let fetchDataFromColumn = menuColMapEntity[lastColumn]?.colData || [];
        let filterNonAlphabetData = fetchDataFromColumn.filter(colValue => {
          return colValue.name !== '';
        });
        if (!filterNonAlphabetData || filterNonAlphabetData.length === 0) {
          let checkNextAlphabetData = this.checkNextAlphabetDataFromColumn(
            menuColMapEntity,
            lastColumn
          );
          if (checkNextAlphabetData) {
            fetchDataFromColumn = checkNextAlphabetData.fetchDataFromColumn;
            filterNonAlphabetData = checkNextAlphabetData.filterNonAlphabetData;
            lastColumn = checkNextAlphabetData.nextColumn;
            pushData = 0;
          }
        }
        let checkDatafromColumn = fetchDataFromColumn.filter(colValue => {
          return colValue.name === value;
        });
        pushData++;
        if (checkDatafromColumn.length > 0) {
          lastPosition = 250 * (lastColumn - 1);
          mapPositionData.set(value, lastPosition);
          if (pushData === filterNonAlphabetData.length) {
            lastColumn++;
            pushData = 0;
          }
        }
      } else {
        mapPositionData.set(value, lastPosition);
      }
    });
    this.setState({ mapPosition: mapPositionData });
  }

  setNoDataArray(avaliableData) {
    const noDataArr = alphabetKeyArray.filter(value => {
      return avaliableData.indexOf(value) == -1;
    });
    this.setState({ alphabetKeyNoDataArray: noDataArr });
  }

  handleAlphaClick = char => {
    this.setState({ defaultSelectedKey: char });
    const { mapPosition } = this.state;
    const scrollLeft = mapPosition.get(char);
    this.scroller.current.scrollLeft = scrollLeft;
  };

  render() {
    const { values, menuColMap, mouseEnter, mouseExit, linkClick, showDirectory } = this.props;
    const { results: menuColMapRes = [], entities: menuColMapEntity = {} } = menuColMap;
    const { defaultSelectedKey, alphabetKeyNoDataArray } = this.state;
    let lastNonEmptyTitle = '';
    const content = values.length ? (
      <div className="flyout-inner">
        <div className="menu-lsec brands" id="inner" ref={this.scroller}>
          {menuColMapRes.map((columnId, i) => {
            const { colData = [] } = menuColMapEntity[columnId] || {};
            return (
              <div className={`column column-${columnId}`} key={i}>
                {colData.map((data, j) => {
                  if (data.name && data.name.trim()) {
                    lastNonEmptyTitle = data.name;
                  }
                  return (
                    <MenuSublistSec linkClick={linkClick} data={data} key={j} isLuxeBrandList groupLabel={lastNonEmptyTitle} />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    ) : null;
    return (
      <div className="brand-list-desktop">
        {showDirectory ? (
          <div className="key-container">
            {alphabetKeyArray.map((item, index) => {
              let isActive = false;
              if (defaultSelectedKey && defaultSelectedKey === item) isActive = true;
              let noDataFound = false;
              if (alphabetKeyNoDataArray.includes(item)) noDataFound = true;
              return (
                <div
                  className={`key-items ${item} ${
                    isActive ? 'is-active' : noDataFound ? 'no-data-found' : ''
                  }`}
                  key={item}
                  onClick={() => {
                    !noDataFound && this.handleAlphaClick(item);
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="key-container">
            <div className="key-items default is-active">BRANDS</div>
          </div>
        )}
        {content}
      </div>
    );
  }
}

export default LuxeBrandList;
